import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import Link from 'components/link';

const Wrapper = styled.div`
  flex: 1;
  ul {
    width: 100%;
  }
  li {
    padding: 0 0 5px 0;
    display: block;
    margin: 0;
    font-size: 14px;
  }
`;

const Header = styled.div`
  font-weight: bold;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin-bottom: 5px;
`;

const StyledLink = styled(Link)`
  color: rgb(237, 237, 237);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledAnchor = styled.a`
  color: rgb(237, 237, 237);
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;

@observer
class FooterColumn extends React.Component {

  render() {
    return (
      <Wrapper>
        <Header>
          {this.props.title}
        </Header>
        <ul>
          {
            this.props.links.map(item => {
              if (item.route) {
                return (
                  <li key={item.name}>
                    <StyledLink to={{ name: item.route }}>
                      {item.name}
                    </StyledLink>
                  </li>
                );
              } else {
                return (
                  <li key={item.name}>
                    <StyledAnchor href={item.link} target="_blank" rel="noopener noreferrer">
                      {item.name}
                    </StyledAnchor>
                  </li>
                );
              }
            })
          }
        </ul>
      </Wrapper>
    );
  }
}

export default ErrorBoundary(FooterColumn);
